export const dictionary = {
  en: {
    accept: "I Agree",
    decline: "I Decline",
    learnmore: "Learn more",
    basicCookieLaw:
      "Noi e terze parti selezionate utilizziamo cookie o tecnologie simili per finalità tecniche e, con il tuo consenso, anche per altre finalità come specificato nella cookie policy.",
    cookieLawTitle: "Cookie Informations",
  },
  it: {
    accept: "Accetto",
    decline: "Rifiuto",
    learnmore: "Approfondisci",
    basicCookieLaw:
      "Noi e terze parti selezionate utilizziamo cookie o tecnologie simili per finalità tecniche e, con il tuo consenso, anche per altre finalità come specificato nella cookie policy.",
    cookieLawTitle: "Informativa sui cookie",
  },
};
